/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/router';
import * as import2 from '../../../app/cloud/cloud.component';
import * as import3 from '../../../app/services/breadcrumbs.service';
const styles_CloudComponent:any[] = ([] as any[]);
export const RenderType_CloudComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CloudComponent,
  data: {}
}
);
export function View_CloudComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'main',[[
        'class',
        'main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import1.RouterOutlet,[
      import1.RouterOutletMap,
      import0.ViewContainerRef,
      import0.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
function View_CloudComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-main',([] as any[]),(null as any),(null as any),(null as any),View_CloudComponent_0,RenderType_CloudComponent)),
    import0.ɵdid(114688,(null as any),0,import2.CloudComponent,[import3.BreadcrumbsService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const CloudComponentNgFactory:import0.ComponentFactory<import2.CloudComponent> = import0.ɵccf('app-main',import2.CloudComponent,View_CloudComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9jbG91ZC9jbG91ZC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3RvcmFnZS92aG9zdC9wYW5lbC5kYXRhc3BhY2UucGwvd2ViL2RhdGFzcGFjZS1jcC1kcy1mcm9udC9zcmMvYXBwL2Nsb3VkL2Nsb3VkLmNvbXBvbmVudC50cyIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9jbG91ZC9jbG91ZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9jbG91ZC9jbG91ZC5jb21wb25lbnQudHMuQ2xvdWRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bWFpbiBjbGFzcz1cIm1haW5cIj5cbiAgICA8ZGl2IGNsYXNzPVwiY29udGFpbmVyXCI+XG4gICAgICAgIDxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cbiAgICA8L2Rpdj5cbjwvbWFpbj4iLCI8YXBwLW1haW4+PC9hcHAtbWFpbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1CO01BQ2Y7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF1QjtJQUNuQjtnQkFBQTs7OztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFBK0I7SUFDN0I7Ozs7OztJQ0hWO2dCQUFBOzs7SUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/cloud/cloud.component.ngfactory.ts